import { FC } from 'react';

import VerticalTimeline from 'primitives/Timeline/VerticalTimeline';

import unitTransferEventTypeToReadable from 'utils/enums/unit-transfer-event-type-to-readable';
import unitTransferEventTypeToTimelineStatus from 'utils/enums/unit-transfer-event-type-to-timeline-status';

type UnitTransferEvent = {
  id: string;
  type: any;
  note?: string | null;
  createdAt: string;
  actor?: { name: string } | null;
};

/**
 * Ops sees every event — visibleToInvestor gates the investor-app timeline, not this one.
 * Shares the VerticalTimeline primitive with the investor app so the same history does not look
 * like two different features depending on which app is open.
 */
const UnitTransferTimeline: FC<{ events: UnitTransferEvent[] }> = ({ events }) => {
  if (events.length === 0) return <p className="text-sm text-gray-500">No activity yet.</p>;

  return (
    <div>
      {events.map((event, index) => (
        <VerticalTimeline
          key={event.id}
          label={unitTransferEventTypeToReadable(event.type)}
          date={event.createdAt}
          status={unitTransferEventTypeToTimelineStatus(event.type)}
          hideStatusLabel
          description={
            event.actor?.name || event.note ? (
              <>
                {event.actor?.name ? (
                  <p className="text-xs text-gray-500">by {event.actor.name}</p>
                ) : null}
                {event.note ? <p className="mt-0.5">{event.note}</p> : null}
              </>
            ) : null
          }
          isLast={index === events.length - 1}
        />
      ))}
    </div>
  );
};

export default UnitTransferTimeline;
